import { createGlobalStyle } from 'styled-components';
import watermark from '../images/watermark.svg';
import anton from './fonts/anton/Anton-Regular.ttf';
import bebasBold from './fonts/bebas/BebasNeue-Bold.otf';
import bebasLigth from './fonts/bebas/BebasNeue-Light.otf';
import bebasRegular from './fonts/bebas/BebasNeue-Regular.otf';

export const GlobalStyles = createGlobalStyle`

  /* Anton */
  @font-face {
    font-family: 'Anton';
    src: url(${anton}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  /* Bebas */
  @font-face {
    font-family: 'Bebas Neue';
    src: url(${bebasLigth}) format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Bebas Neue';
    src: url(${bebasRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Bebas Neue';
    src: url(${bebasBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
  }
  
  html, body{
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    background-color: ${({ theme }) => theme.colors.grey[800]};
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey.white};
    scroll-behavior: smooth;
  }

  button{
    cursor: pointer;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  *:focus-visible{      
    outline: 2px solid ${({ theme }) => theme.colors.secondary.main};
  }

  .watermark{
    position: relative;
    background-color: ${({ theme }) => theme.colors.grey.black};

    &::before{
      content: '';
      position: absolute;
      inset: 0;
      background-image: url(${watermark});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      opacity: 0.6;
      pointer-events: none;
      z-index: 1;
    }
  }

`;
